import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import './../../styles/sendmail.scss';


function SendMail (){
const [status, setStatus] = useState(true)
const form = useRef();
const sendEmail = (e) => {
  e.preventDefault();
  emailjs
    .sendForm('service_07tdr1v', 'template_3tes3c9', form.current,  {
        publicKey: 'yRiafbPoaajspI1eS',
      }
    )
    .then(
      () => {
        console.log('SUCCESS!');
      },
      (error) => {
        console.log('FAILED...', error.text, form);
      },
    );
    setStatus(false)
};

return (
    <>
      { status && (
        <form ref={form} id="contact-form" onSubmit={sendEmail}>
          <div class="input mb">
            <div class="hidden">
              <label for="name" class="required">Name</label>
            </div>
            <div class="icon-container">
              <input type="text" name="name" id="name" placeholder="Name" class="icon-content" required />
            </div>
          </div>

          <div class="input mb">
            <div class="hidden">
              <label for="email" class="required">Email</label>
            </div>
            <div class="icon-container">
              <input type="email" name="email" id="email" placeholder="Email" class="icon-content" required/>
            </div>
          </div>

          <div class="input mb">
            <div class="hidden">
                <label for="subject" class="required">Subject</label>
            </div>
          <div class="icon-container">
              <input type="text" name="subject" id="subject" placeholder="Subject" class="icon-content" required/>
            </div>
          </div>

          <div class="input mb">
            <div class="hidden">
              <label for="message" class="required">Message</label>
            </div>
            <div class="icon-container">
              <textarea name="message" id="message" cols="10" rows="5" placeholder="Message..." class="icon-content" required></textarea>
            </div>
          </div>

           <div class="input mb">
              <button type="submit" class="btn text-center">Send Message</button>
            </div>
        </form>
      )}
      { !status && (
        <p style={{
            marginTop:'30px',
            color:'gray',
            fontSize: '20px',
            textAlign: 'center',
        }}>Сообщение отправлено</p>
      ) 

      }
    </>)}

export default SendMail;